class TemplatesController{
  /**
   *
   * @param $translates
   * @param $state
   */
  constructor(
    $translates,
    $state
  ){
    'ngInject';
    this.$translates  = $translates;
    this.$state       = $state;
    this.prepareLanguages();
  }
  prepareLanguages(){
    this.languages = Object.keys(this.$translates.get());
  }
  changeLanguage( key ){
    this.$translates.setLanguage( key );
    location.reload();
  }
}

export default TemplatesController;


/** WEBPACK FOOTER **
 ** ./frontend/components/translates/translates.controller.js
 **/